import { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { WcedLogo, HulaTechLogo } from '../shared/components';
const WelcomeOverlay = () => {
  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    const hasVisited = localStorage.getItem('hasVisited');
    if (!hasVisited) {
      setShowOverlay(true);
      localStorage.setItem('hasVisited', 'true');

     
      const timer = setTimeout(() => {
        setShowOverlay(false);
      }, 1280);

      return () => clearTimeout(timer);
    }
  }, []);

  if (!showOverlay) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        bgcolor: 'rgba(0,125,186, 0.98)',
        zIndex: 1300, 
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        transition: 'opacity 0.5s ease', 
        opacity: showOverlay ? 1 : 0,
      }}
    >
      <WcedLogo />
      <Typography variant="h1" sx={{ mb: 2 }} paddingTop="40px">
        Career Clubs
      </Typography>
      <Box
        sx={{
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
        }}
      >
        <Typography variant="body2">Powered by</Typography>
        <HulaTechLogo variant="white" height="60px" width="100px" />
        <Typography variant="body2">Technology</Typography>
      </Box>
    </Box>
  );
};

export default WelcomeOverlay;
